function view_orders_on_map(sender) {
    const $ = jQuery.noConflict();
    const elm = $(sender);
    elm.toggle();
    elm.next().toggle();
    const mapWrapper = get_map_wrapper(elm);
    setTimeout(() => {
        mapWrapper.addClass('show');
    }, 50);

    const table = mapWrapper.next();

    // First get all data from the table
    // Load the map
    // Put the dots together
    // If there's more data in the table, after scroll, get that on-the-fly
    // Also add the new data to the map




    const bounds  = new google.maps.LatLngBounds();
    const map = new google.maps.Map(
        mapWrapper[0], {zoom: 8});

    place_missing_rows_on_map();

    function place_missing_rows_on_map() {
        const markers = [];
        table.find('tr[data-id]:not(.on-map)').each(function() {
            const tr = $(this);
            const order = tr.getThisElementsData();

            const marker = new google.maps.Marker({
                animation: google.maps.Animation.DROP,
                position: {lat: order.lat, lng: order.lng},
                map: map,
                title: order.client.name
            });
            markers.push(marker);

            const infoDiv = $('<div></div>');
            const infoTable = $('<table></table>');
            // let infoTr = infoTable.find('tr');

            const infoTr = tr.clone(true, true);

            const colsToCopy = table.find('th[data-col-key]').parent().find('th').clone();
            infoTable.prepend('<thead></thead>');
            infoTable.find('thead').prepend(colsToCopy);
            infoTable.find('a').each(function() {
                $(this).replaceWith($(this).text());
            });

            infoTable.append('<tbody></tbody>');
            infoTable.find('tbody').append(infoTr);

            infoDiv.append(infoTable);

            const infoWindow = new google.maps.InfoWindow({
                content: infoDiv.html()
            });

            marker.addListener('click', () => {
                infoWindow.open(map, marker);
            });

            const location = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(location);

            tr.addClass('on-map');
        });

        map.fitBounds(bounds);
        map.panToBounds(bounds);

        const markerCluster = new MarkerClusterer(map, markers,
            {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', maxZoom: 7});
    }

    
    return false;
}
function hide_orders_map(sender) {
    const $ = jQuery.noConflict();
    const elm = $(sender);
    elm.toggle();
    elm.prev().toggle();
    const mapWrapper = get_map_wrapper(elm);
    mapWrapper.next().find('tr.on-map').removeClass('on-map');

    mapWrapper.removeClass('show');
    setTimeout(() => {
        mapWrapper.remove();
    }, 250);
    
    return false;
}

function get_map_wrapper(elm) {
    const $ = jQuery.noConflict();
    let table;
    let child = elm;
    while((!table || table.length === 0) && child.prop('tagName') !== 'BODY') {
        table = child.parent().find('.scrollable-table');
        child = child.parent();
    }

    if (table) {
        if (table.prev().hasClass('map-wrapper')) {
            return table.prev();
        }
        const div = $('<div></div>');
        div.addClass('map-wrapper');
        table.before(div);
        return div;
    }
}